export default "__VITE_ASSET__DeMx09pE__"